var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.899,
    height: 39.809,
    viewBox: "0 0 36.899 39.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0055ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.219)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.994,37.528H24.611A5.118,5.118,0,0,1,19.5,32.416V7.392a5.118,5.118,0,0,1,5.111-5.111H35.163a1.141,1.141,0,1,0,0-2.281H24.611a7.4,7.4,0,0,0-7.392,7.392V32.416a7.4,7.4,0,0,0,7.392,7.392H34.994a1.141,1.141,0,1,0,0-2.281Z",
    transform: "translate(-17.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.356,143.91l-7.249-7.249a1.141,1.141,0,0,0-1.614,1.614l5.306,5.306H121.66a1.141,1.141,0,1,0,0,2.281H144.8l-5.306,5.306a1.145,1.145,0,0,0,.8,1.952,1.113,1.113,0,0,0,.8-.338l7.249-7.249A1.14,1.14,0,0,0,148.356,143.91Z",
    transform: "translate(-111.792 -124.808)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.957034be.svg";
export { ForwardRef as ReactComponent };